import { triggerRefresh as refreshRelationshipCompanies } from '@/features/table/relationshipCompaniesTableSlice';
import { triggerRefresh as refreshRelationshipContacts } from '@/features/table/relationshipContactsTableSlice';

const TYPESENSE_REFRESH_DELAY = 10000;

export const refreshTypesenseTables = (dispatch) => {
	setTimeout(() => {
		dispatch(refreshRelationshipCompanies());
		dispatch(refreshRelationshipContacts());
	}, TYPESENSE_REFRESH_DELAY);
};
